import * as React from 'react';
import { useReactToPrint } from 'react-to-print';
import { makeStyles } from "@material-ui/core/styles";

const getPageMargins = () => {
    return `
    @media print {
      width : 205mm;
      margin-left: 100px;
      padding:'60px';
    }
    `;
  };
const fontSize = () =>{
  return `@media print { 
    table td span, table th span, table td p, table th p, div span{
      // font-size:12pt;
      line-height:1.8;
    }
  }`;
}

const a4Styles = makeStyles({
  centreItems: {
      display: 'flex',
      justifyContent: 'center'
  },
  emergencyListView: {
    display: 'flex',
    justifyContent: 'center',
  //  width: '100%'
  },
});

function usePrint(title, onAfterPrint) {
    const componentRef = React.useRef();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
      documentTitle: title,
      onAfterPrint
    });

    return {componentRef, handlePrint, getPageMargins,fontSize, a4Styles}  
}
export {usePrint}